
const CommonMethods = {}
const add0 = (num) => {
  return num < 10 ? '0' + num : '' + num
}

const parseDate = function (date) {
  var y = date.getFullYear()
  var m = add0(date.getMonth() + 1)
  var d = add0(date.getDate())
  var h = add0(date.getHours())
  var min = add0(date.getMinutes())
  var sec = add0(date.getSeconds())
  return {year: y, month: m, day: d, hour: h, minute: min, second: sec}
}

const formatDate1 = function (date) {
  // const {year, month, day, hour, minute, second} = parseDate(date)
  // return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  let timeStr = new Date(date)
  let filter = timeStr.toString().split(' ')
  // let num = `${filter[4][0]}${filter[4][1]}`
  // // console.log(num)
  // let str = num >= 12 ? 'PM' : 'AM'
  // var hour = num % 12
  // var seconds
  // if (num > 12 && hour < 10) {
  //   seconds = `0${hour}${filter[4].slice(2, 8)}`
  // } else if (num > 12 && hour < 12) {
  //   seconds = `${hour}${filter[4].slice(2, 8)}`
  // } else {
  //   seconds = filter[4]
  // }
  // console.log(seconds)
  // console.log(filter)
  let result = `${filter[1]} ${filter[2]},${filter[3]}`
  return result
}

const formatDate5 = function (date) {
  // const {year, month, day, hour, minute, second} = parseDate(date)
  // return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  let timeStr = new Date(date)
  let filter = timeStr.toString().split(' ')
  let num = `${filter[4][0]}${filter[4][1]}`
  // console.log(num)
  let str = num >= 12 ? 'PM' : 'AM'
  var hour = num % 12
  var seconds
  if (num > 12 && hour < 10) {
    seconds = `0${hour}${filter[4].slice(2, 8)}`
  } else if (num > 12 && hour < 12) {
    seconds = `${hour}${filter[4].slice(2, 8)}`
  } else {
    seconds = filter[4]
  }
  // console.log(seconds)
  // console.log(filter)
  let result = `${filter[1]} ${filter[2]},${filter[3]}, ${seconds} ${str}`
  return result
}

const formatDate4 = function (date) {
  // const {year, month, day, hour, minute, second} = parseDate(date)
  // return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  let timeStr = new Date(date)
  var week = ''
  if (timeStr.getDay() === 0) week = 'Sunday'
  if (timeStr.getDay() === 1) week = 'Monday'
  if (timeStr.getDay() === 2) week = 'Tuesday'
  if (timeStr.getDay() === 3) week = 'Wednesday'
  if (timeStr.getDay() === 4) week = 'Thursday'
  if (timeStr.getDay() === 5) week = 'Friday'
  if (timeStr.getDay() === 6) week = 'Saturday'
  console.log(week)
  let filter = timeStr.toString().split(' ')
  let num = `${filter[4][0]}${filter[4][1]}`
  // console.log(num)
  // let str = num >= 12 ? 'PM' : 'AM'
  var hour = num % 24
  var seconds
  if (num > 24 && hour < 10) {
    seconds = `0${hour}${filter[4].slice(2, 8)}`
  } else if (num > 24 && hour < 24) {
    seconds = `${hour}${filter[4].slice(2, 8)}`
  } else {
    seconds = filter[4]
  }
  // console.log(seconds)
  // console.log(filter)
  let result = `${filter[1]} ${filter[2]},${filter[3]},${week}, ${seconds}`
  return result
}

const formatDate2 = function (date) {
  const {year, month, day, hour, minute, second} = parseDate(date)
  return `${year}-${month}-${day}_${hour}-${minute}-${second}`
}

const formatDate3 = function (date) {
  const {year, month, day, hour, minute, second} = parseDate(date)
  return `${year}${month}${day}${hour}${minute}${second}`
}

CommonMethods.install = (Vue, options = {}) => {
  Vue.prototype.$Key = (title, index) => {
    return `${title}-${index}`
  }
  Vue.prototype.$Image = (imgName) => {
    return `static/images/${imgName}`
  }
  Vue.prototype.$Formatter = {
    duration: function (second) {
      if (!second || second <= 0 || isNaN(second)) {
        return ''
      }
      const min = parseInt(second / 60)
      const hours = parseInt(min / 60)
      const sec = parseInt(second - min * 60)
      const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      // return add0(hours) + 'h' + add0(minAdjust) + 'mins' + add0(sec)
      // const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      if (sec < 60 && minAdjust === 0 && hours === 0) {
        return '<1 mins'
      } else if (hours === 0) {
        return add0(minAdjust) + 'mins'
      } else {
        return add0(hours) + 'h' + ' ' + add0(minAdjust) + 'mins'
      }
    },
    durationOne: function (second) {
      if (!second || second <= 0 || isNaN(second)) {
        return 0 + 'min'
      }
      const min = parseInt(second / 60)
      const hours = parseInt(min / 60)
      const sec = parseInt(second - min * 60)
      const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      // return add0(hours) + 'h' + add0(minAdjust) + 'mins' + add0(sec)
      // const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      if (sec < 60 && minAdjust === 0 && hours === 0) {
        return '<1 mins'
      } else if (hours === 0) {
        return add0(minAdjust) + 'mins'
      } else {
        return add0(hours) + 'h' + ' ' + add0(minAdjust) + 'mins'
      }
    },
    durationHome: function (second) {
      if (!second || second <= 0 || isNaN(second)) {
        return 0 + 'min'
      }
      const min = parseInt(second / 60)
      const hours = parseInt(min / 60)
      const sec = parseInt(second - min * 60)
      const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      // return add0(hours) + 'h' + add0(minAdjust) + 'mins' + add0(sec)
      // const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      if (sec < 60 && minAdjust === 0 && hours === 0) {
        return '1 mins'
      } else if (hours === 0) {
        return minAdjust + 'mins'
      } else {
        return hours + 'h' + minAdjust + 'mins'
      }
    },
    durationSreenTime: function (second) {
      if (!second || second <= 0 || isNaN(second)) {
        return 0
      }
      const min = parseInt(second / 60)
      const hours = parseInt(min / 60)
      const sec = parseInt(second - min * 60)
      const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      if (sec < 60 && minAdjust === 0 && hours === 0) {
        return 0.1
      } else if (hours === 0) {
        return '0.' + minAdjust
      } else {
        return hours + '.' + minAdjust
      }
    },
    durationSavePeriod: function (second) {
      if (!second || second <= 0 || isNaN(second)) {
        return '00:00:00'
      }
      const min = parseInt(second / 60)
      const hours = parseInt(min / 60)
      const sec = parseInt(second - min * 60)

      const minAdjust = parseInt((second / 60) - (60 * parseInt((second / 60) / 60)))
      return add0(hours) + ':' + add0(minAdjust) + ':' + add0(sec)
    },
    size: function (bytes, fixed = 1) {
      if (!bytes || bytes <= 0) {
        return '0 B'
      }
      const KB = 1024
      const MB = 1024 * KB
      const GB = 1024 * MB
      if (bytes / GB >= 1) {
        return `${(bytes / GB).toFixed(fixed)} GB`
      } else if (bytes / MB >= 1) {
        return `${(bytes / MB).toFixed(fixed)} MB`
      } else if (bytes / KB >= 1) {
        return `${(bytes / KB).toFixed(fixed)} KB`
      } else {
        return `${bytes.toFixed(fixed)} B`
      }
    },
    date: function (second) {
      if (!second) {
        return formatDate1(new Date())
      }
      return formatDate1(second)
    },
    dateHistroy: function (second) {
      if (!second) {
        return formatDate5(new Date())
      }
      return formatDate5(second)
    },
    dateGeo: function (second) {
      if (!second) {
        return formatDate4(new Date())
      }
      return formatDate4(second)
    },
    dateInPath: function (date) {
      return formatDate2(date)
    },
    oldVersionDateInPath: function (date) {
      return formatDate3(date)
    },
    title: function (name) {
      let fixName = name
      const str = ['\\', '/', ':', '*', '?', '"', '<', '>', '|', '.']
      for (let i = 0; i < str.length; ++i) {
        const reg = `/\\${str[i]}/`
        fixName = fixName.replace(new RegExp(reg, 'g'), '_')
      }
      return fixName
    }
  }
  // use to define some const data
  Vue.prototype.$Common = {
    isArray: function (v) {
      return toString.apply(v) === '[object Array]'
    },
    isObject: function (v) {
      return (v !== null && typeof v === 'object')
    }
  }
}

export default CommonMethods



// WEBPACK FOOTER //
// ./src/CommonMethods.js